export const config = {
  api_local: process.env.REACT_APP_API_URL, 
  url_789bet: "789bet",
  BE_API_URL: process.env.REACT_APP_API_URL,
};